import { useMutation, useQuery } from "@tanstack/react-query"
import { getRewardsPageText, updateRewardsPageText } from "../api/rewardsConfig";

export const useGetRewardsPageText = (screenName) => {
    return useQuery({
        queryKey: ["rewardsPageText", screenName],
        queryFn: () => getRewardsPageText(screenName),
        enabled: !!screenName,
    });
}

export const useUpdateRewardsPageText = () => {
    return useMutation({
        mutationKey: ["updateRewardsPageText"],
        mutationFn: (data) => updateRewardsPageText(data),
    });
}